export const cpfFormat = (document?: string) =>
  `${document ?? ''}`
    .replace(/[^\d]+/g, '')
    .replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})$/g, '$1.$2.$3-$4');
